module.exports = __webpack_public_path__ + "img/icons8-upload.6a870f35.svg";